module.exports = __webpack_public_path__ + "static/banner-2-ebc07cc77ed9e70c837ed24d36774fcb.jpg";